import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var BraceLeft = props => {
  var {
    BraceLeft: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BraceLeft');
  return null;
};
BraceLeft.displayName = 'JVR.BraceLeft';